module.exports = __webpack_public_path__ + "static/stempel-f6b22df0eb6e26a0ccfd24aa2f1ede01.jpg";